import { useQuery } from '@tanstack/react-query'
import { fetchWithPagination } from '../../api/admin/mailQueue'

const key = 'admin.mailQueue'

export const useList = (queryParams) => {
  return useQuery({
    queryKey: [key, queryParams],
    queryFn: () => fetchWithPagination(queryParams)
  })
}
